import { inject, Injectable, signal } from '@angular/core';
import { defer, finalize, Observable } from 'rxjs';
import { ContactValidationApiService } from './contact-validation-api.service';

@Injectable({
  providedIn: 'root',
})
export class ContactValidationDatasourceService {
  private readonly apiService = inject(ContactValidationApiService);
  public $isLoading = signal<boolean | undefined>(undefined);

  public validateMailAddress(id: string): Observable<string> {
    return this.withLoading(this.apiService.validateMailAddress(id));
  }

  public revokeMailAddress(id: string): Observable<string> {
    return this.withLoading(this.apiService.revokeMailAddress(id));
  }

  private withLoading<T>(source: Observable<T>): Observable<T> {
    return defer(() => {
      this.$isLoading.set(true);
      return source.pipe(finalize(() => this.$isLoading.set(false)));
    });
  }
}
